<table mat-table [dataSource]="items">
    <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>{{ 'ShareStatistics.Security' | translate }}</th>
        <td mat-cell *matCellDef="let item">{{ item.label }}</td>
    </ng-container>
    <ng-container matColumnDef="registeredShares">
        <th mat-header-cell class="text-right" *matHeaderCellDef>{{ 'ShareStatistics.RegisteredShares' | translate }}</th>
        <td mat-cell class="text-right" *matCellDef="let item">{{ item.registeredShares | slNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="value">
        <th mat-header-cell class="text-right" *matHeaderCellDef>{{ valueKeyText | translate }}</th>
        <td mat-cell class="text-right" *matCellDef="let item">{{ item.value | slNumber }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
